import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Ship } from 'lucide-react';

const Hero: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1494412651409-ae1e0954332e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2500&q=80" 
          alt="Container Ship Port" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-marine-500/20 border border-marine-400/30 text-marine-200 text-sm font-medium mb-6 backdrop-blur-sm">
            <Ship className="h-4 w-4" />
            <span>{t('hero.leading_maritime')}</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight mb-6 leading-tight">
            {t('hero.gateway_to')} <br/>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-marine-300 to-white">{t('hero.global_trade')}</span>
          </h1>

          <div className="border-l-4 border-marine-500 pl-6 mb-8 bg-white/5 py-4 pr-4 backdrop-blur-sm rounded-r-lg max-w-2xl">
            <p className="text-xl md:text-2xl text-slate-100 leading-relaxed mb-2">
              {t('hero.ar_stevedoring')}
            </p>
            <p className="text-lg md:text-xl text-marine-200">
              {t('hero.ar_agency')}
            </p>
          </div>

          <p className="text-lg text-slate-300 mb-10 max-w-xl">
             {t('hero.desc')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">

            <a href="#services" className="inline-flex items-center justify-center px-8 py-4 bg-white/10 text-white font-semibold rounded-lg hover:bg-white/20 transition-all backdrop-blur-sm border border-white/20">
              {t('hero.explore')}
              <Box className="ml-2 h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Hero;
